/**
 * @component AdminLoginPanel
 * @description 관리자 콘솔 진입 전 인증 키를 입력받는 로그인 카드입니다.
 * @usage AdminPage에서 미인증 상태일 때 렌더링됩니다.
 */

import { useState } from 'react';

export default function AdminLoginPanel({ onSubmit, isSubmitting, errorMessage, onClearError }) {
  const [password, setPassword] = useState('');

  // [기능] 폼 제출 시 입력한 키로 로그인을 시도합니다.
  // [기술] form onSubmit으로 처리해 Enter 키 제출과 브라우저 기본 동작을 함께 지원합니다.
  const handleSubmit = (event) => {
    event.preventDefault();
    if (isSubmitting || !password.trim()) return;
    onSubmit(password);
  };

  const handleChange = (event) => {
    setPassword(event.target.value);
    if (errorMessage) onClearError();
  };

  return (
    <div className="admin-login-wrap">
      <form className="admin-login-card" onSubmit={handleSubmit}>
        <h1 className="admin-login-title">관리자 로그인</h1>
        <p className="admin-login-desc">연혁 · 뉴스 · FAQ를 관리하려면 관리자 키를 입력하세요.</p>

        <input
          type="password"
          className={`admin-input admin-login-input${errorMessage ? ' is-error' : ''}`}
          value={password}
          onChange={handleChange}
          placeholder="관리자 키"
          autoComplete="current-password"
          autoFocus
        />

        <p className="admin-login-error">{errorMessage || ' '}</p>

        <button type="submit" className="admin-btn admin-btn-primary admin-login-submit" disabled={isSubmitting || !password.trim()}>
          {isSubmitting ? '확인 중...' : '로그인'}
        </button>
      </form>
    </div>
  );
}
